import { from, of, throwError } from 'rxjs';
import { withLatestFrom, switchMap, catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AuthService } from './auth.service';
import * as AuthActions from 'store/actions/auth.actions';
import { Selectors } from 'store/root-reducer';
var TokenInterceptorService = /** @class */ (function () {
    function TokenInterceptorService(auth, store) {
        this.auth = auth;
        this.store = store;
    }
    TokenInterceptorService.prototype.intercept = function (request, next) {
        var _this = this;
        return from(this.auth.getSession())
            .pipe(withLatestFrom(this.store.select(Selectors.domain.getCurrentDomain)), switchMap(function (_a) {
            var session = _a[0], domain = _a[1];
            request = request.clone({
                setHeaders: {
                    Authorization: "Bearer " + session.accessToken.jwtToken,
                    'X-ARTEMIS-DOMAIN': domain ? String(domain.id) : ''
                }
            });
            return next.handle(request);
        }), catchError(function (err) {
            if (err === 'NotAuthenticated' || (err.error && err.error.detail === 'The token provided is invalid')) {
                _this.store.dispatch(new AuthActions.LogOut({ isSessionTimeOut: false }));
                return of(err);
            }
            else {
                return throwError(err);
            }
        }));
    };
    return TokenInterceptorService;
}());
export { TokenInterceptorService };
